import React from 'react';
import styles from './Keyboard.module.css'; // Import css modules stylesheet as styles

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export default class Keyboard extends React.Component {
	keyboardRef = React.createRef();
	keyboardRange = [9+12, 88+9+12]; // [x, y)
	whiteKeyCount = 0;
	activeNotes = [];
	
	componentDidMount() {
		this.keyboardRef.current.style.setProperty("--whiteKey_Count", this.whiteKeyCount);
		Keyboard.singleton = this
		
		// this.playNote(50);
		// this.playNote(54);
		// this.playNote(57);
	}
	
	note2Key(note) {
		let keyboard = this.keyboardRef.current;
		
		return keyboard.children[note - this.keyboardRange[0]];
	}

	playNote(note, channelId, color){
		if(this.props.welcomePageOpened){
			return;
		}

		const key = this.note2Key(note);
		if(key){
			const noteNameSpan = key.firstChild;
			
			this.updateKeyColor(key, "down", color);
			noteNameSpan.style.visibility = "visible";
		}

		if(!this.activeNotes.find(n => n.note == note && n.channel == channelId)){
			this.activeNotes.push({
				note: note,
				color: color,
				channelId: channelId,
			});
		}
	}
	
	releaseNote(note, channel, c){
		const index = this.activeNotes.findIndex(n => n.note == note && n.channel == channel)
		
		if(index >= 0){
			this.activeNotes.splice(index, 1)
		}

		if(!this.activeNotes.find(n => n.note == note)){
			const key = this.note2Key(note);
			if(key){
				const noteNameSpan = key.firstChild;
				
				this.updateKeyColor(key, "up", c);
				noteNameSpan.style.visibility = "hidden";
			}
		}
	}

	releaseAllNote(c){
		this.activeNotes = [];
		let keyboard = this.keyboardRef.current;
		if(keyboard){
			for(let key of keyboard.children){
				const noteNameSpan = key.firstChild;
			
				this.updateKeyColor(key, "up", c);
				noteNameSpan.style.visibility = "hidden";
			}
		}
	}

	checkNoteActive(note, channel){
		return this.activeNotes.find(n => n.note == note  && n.channel == channel);
	}
	
	updateKeyColor(key, keyState, c){
		if (c == undefined) {
			c = "#e3b022";
		}
	
		let keyColor = key.classList.contains(styles.white) ? "white" : "black"
		if     (keyColor=="white" && keyState=="up"  ){key.style.backgroundColor = "#FFFFFF"}
		else if(keyColor=="white" && keyState=="down"){key.style.backgroundColor = c}
		else if(keyColor=="black" && keyState=="up"  ){key.style.backgroundColor = "#000000"}
		else if(keyColor=="black" && keyState=="down"){key.style.backgroundColor = c}
	}
	
	render() {
		
		let octaveBlackWhite = ['w', 'b', 'w', 'b', 'w', 'w', 'b', 'w', 'b', 'w', 'b', 'w'];
		let octaveNoteNames = ['c', 'cs', 'd', 'ds', 'e', 'f', 'fs', 'g', 'gs', 'a', 'as', 'b'];
		let octaveDisplayedNoteNames = ['C', 'C', 'D', 'D', 'E', 'F', 'F', 'G', 'G', 'A', 'A', 'B'];
		let octaveDisplayedNoteSharpFlatss = ['', '♯', '', '♯', '', '', '♯', '', '♯', '', '♯', ''];
		
		this.whiteKeyCount = 0;
		for (let i = this.keyboardRange[0]; i < this.keyboardRange[1]; i++) {
			if (octaveBlackWhite[i%12] == 'w') {
				this.whiteKeyCount++;
			}
		}
		
		const createKeyboard= ()=> {
			let keys = [];
			
			for (let i = this.keyboardRange[0]; i < this.keyboardRange[1]; i++) {
				let key = null;
				
				let octaveLabel = null;
				if (i%12 == 0) {
					octaveLabel = (
						<span className={styles.keyOctaveLabel}>{Math.floor(i/12) -1}</span>
					)
				}
				
				if (octaveBlackWhite[i%12] == 'w') {
					let displayedNoteName = octaveDisplayedNoteNames[i%12];

					displayedNoteName = this.props.isCompactKeyboard? null : displayedNoteName;

					key = (
						<div key={i} className={ styles.key + " " + styles.white + " " + styles[octaveNoteNames[i%12].toString()] }>
							<span note={displayedNoteName} className={styles.keyNoteNameLabel}>
								{displayedNoteName}
							</span>
							{this.props.isCompactKeyboard? null : octaveLabel}
						</div>
					);
				} else {
					let displayedNoteName = octaveDisplayedNoteNames[i%12] + octaveDisplayedNoteSharpFlatss[i%12];

					displayedNoteName = this.props.isCompactKeyboard? null : displayedNoteName;

					key = (
						<div key={i} className={ styles.key + " " + styles.black + " " + styles[octaveNoteNames[i%12].toString()] }>
							<span note={displayedNoteName} className={styles.keyNoteNameLabel}>
								{displayedNoteName}
							</span>
						</div>
					);
				}
				
				keys.push(key);
			}
			
			return (
				<Box ref={this.keyboardRef} className={styles.keyboard}>
					
					{keys}
				</Box>
			)
		}
		
		// element.style.setProperty("--whiteKey_Count", whiteKeyCount.toString());
		
		return createKeyboard();
	}
}
